module.exports = __webpack_public_path__ + "static/media/leopard_head_orientation_front copy.7379081e.jpeg";